import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const MentionsLegales = () => {
  return (
    <>
      <Helmet>
        <title>Mentions Légales - Roca Rio | Agence de Tourisme à Rio de Janeiro</title>
        <meta name="description" content="Mentions légales de Roca Rio, agence de tourisme locale et engagée à Rio de Janeiro. Informations légales, éditeur, hébergement et responsabilité." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Header />
      
      <main className="bg-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
          <header className="mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">Mentions Légales</h1>
            <p className="text-lg text-muted-foreground">Informations légales relatives au site Roca Rio</p>
          </header>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Éditeur du site</h2>
              <div className="bg-muted/50 p-6 rounded-lg">
                <p><strong>Nom commercial :</strong> Roca Rio</p>
                <p><strong>Responsable de publication :</strong> Cléa Le Chanjour</p>
                <p><strong>Contact :</strong> contact.rocario@gmail.com</p>
                <p><strong>Téléphone :</strong> +55 21 97679 5050</p>
                <p><strong>Siège :</strong> Rio de Janeiro, Brésil</p>
                <p><strong>CNPJ :</strong> 62.527.088/0001-51</p>
                <p><strong>Guide répertoriée au ministère du tourisme brésilien :</strong> 19.929266.64-1</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Hébergement</h2>
              <div className="bg-muted/50 p-6 rounded-lg">
                <p>Le site est hébergé par <strong>Lovable</strong>.</p>
                <p><strong>Siège social :</strong> 2261 Market Street #4321, San Francisco, CA 94114, États-Unis.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Activité</h2>
              <p className="text-muted-foreground">
                Roca Rio est une agence de tourisme locale et engagée à Rio de Janeiro, proposant des excursions, 
                transferts et services d'accompagnement.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Propriété intellectuelle</h2>
              <p className="text-muted-foreground">
                L'ensemble du contenu du site (textes, images, graphismes, logo, vidéos) est protégé par le droit d'auteur. 
                Toute reproduction ou utilisation sans autorisation est interdite.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Responsabilité</h2>
              <p className="text-muted-foreground">
                Les informations diffusées sur ce site sont fournies à titre indicatif. Roca Rio ne saurait être tenue 
                responsable d'erreurs ou omissions.
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </>
  );
};

export default MentionsLegales;